<template>
  <div>
    <div class="section-hero-subpage bg-color-octrary">
      <video autoplay loop muted playsinline width="640" preload="metadata" poster="/frontend/assets/images/og-image.jpg">
        <source src="/frontend/assets/videos/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="container">
        <div class="paragraph--normal text-uppercase text-color-quinary mb-2">
          <span class="notranslate" translate="no">SELECTED</span> CARS
        </div>
        <h1
          class="heading--0 text-uppercase text-color-quinary border-bottom-quinary padding-bottom-2 margin-bottom-3-lg"
        >
          Page <span class="fw-light">not</span><br />
          found
        </h1>
        <div class="row">
          <div class="col-lg-7">
            <p class="paragraph--xlarge text-color-senary">
              The page you are looking for doesn't exist or has been moved.
              Let us help you find the perfect car instead.
            </p>
          </div>
        </div>
        <div class="mt-5 d-flex flex-wrap gap-3">
          <router-link
            to="/"
            class="btn btn--normal btn--primary text-uppercase"
          >
            Go Home
          </router-link>
          <router-link
            to="/inventory"
            class="btn btn--normal btn--primary text-uppercase"
          >
            Browse Inventory
          </router-link>
          <router-link
            to="/contacts"
            class="btn btn--normal btn--primary text-uppercase"
          >
            Contact Us
          </router-link>
        </div>
      </div>
    </div>
    <AppMarquee />
  </div>
</template>

<script>
import AppMarquee from '../components/AppMarquee.vue';

export default {
  components: {
    AppMarquee
  },
  mounted() {
    import('../seo.js').then(({ setPageSeo }) => setPageSeo({
      title: '404 — Page Not Found | Selected Cars',
      description: 'The page you are looking for was not found. Browse our premium European car inventory or contact us for car export inquiries.',
      keywords: 'selected cars, page not found, european car exporter'
    }));

    // Set proper 404 meta for search engines
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, follow');
    }
  },
  beforeUnmount() {
    // Restore robots meta when leaving 404 page
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    }
  }
};
</script>
